import { useEffect } from "react";
import "./DataFlowVisualization.css";

interface DataModalProps {
  data: any;
  isOpen: boolean;
  onClose: () => void;
  title?: string;
}

/**
 * Modal component for displaying JSON data
 */
export default function DataModal({
  data,
  isOpen,
  onClose,
  title = "Data Details",
}: DataModalProps) {
  useEffect(() => {
    if (isOpen) {
      // Prevent body scroll when modal is open
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleEscape);
    }

    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div className="data-modal-overlay" onClick={onClose} />
      {/* Modal */}
      <div className="data-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="data-modal-title">{title}</h3>
        <pre className="data-modal-content">
          {JSON.stringify(data, null, 2)}
        </pre>
        <button className="data-modal-close-button" onClick={onClose}>
          Close
        </button>
      </div>
    </>
  );
}
